// src/pages/AccessPendingPage.js
import React from 'react';

export default function AccessPendingPage() {
  return (
    <div style={{ maxWidth: 520, margin: '80px auto', padding: '24px' }}>
      <h1>Access request received</h1>
      <p style={{ marginTop: 12 }}>
        Thanks for signing up for CuvrIQ. Your account is currently pending approval.
      </p>
      <p style={{ marginTop: 12 }}>
        Once we review your request and assign a role to your account,
        you’ll get full access to the platform.
      </p>
      <p style={{ marginTop: 12 }}>
        If you believe this is an error, please contact us at support@cuvriq.com.
      </p>
    </div>
  );
}
